import axios from '@/libs/api.request';

export const getDepartmentList = data => {
    return axios.request({
        url: 'api/systemManagement/departmentManagement/getDepartmentList',
        data: data,
        method: 'post'
    });
};

export const saveDepartment = data => {
    return axios.request({
        url: 'api/systemManagement/departmentManagement/saveDepartment',
        data: data,
        method: 'post'
    });
};
export const deleteDepartment = data => {
    return axios.request({
        url: 'api/systemManagement/departmentManagement/deleteDepartment',
        data: data,
        method: 'post'
    });
};
